import { AllFoodType, FoodType, MealType, WithIngredientsType } from "model/food/types"
import {
  IAIScanFoodOption,
  IAIScanFoodResponse,
  IAIScanPackageFoodOption,
} from "model/food/types/AIScan.types"
import { IEdamaFood } from "model/food/types/edama.types"
import { IMyFood } from "model/food/types/myfood.types"
import { IOpenFoodFactFood } from "model/food/types/openFoodFact.types"

export function isEdamaFood(food: AllFoodType | MealType): food is IEdamaFood {
  return food.source === "EDAMAM"
}

export function isMyFood(food: AllFoodType | MealType): food is IMyFood {
  return food.source === "MY_FOOD"
}

export function isOpenFoodFactFood(
  food: AllFoodType,
): food is IOpenFoodFactFood {
  return food.source === 'OPEN_FOOD_FACTS'
}

export function isAIScanFoodResponse(
  food: AllFoodType,
): food is IAIScanFoodResponse {
  return food.source === "AI_SCAN_MEAL"
}

export const isAIScanFoodOption = (
  food: AllFoodType,
): food is IAIScanFoodOption => {
  return food.source === "AI_SCAN_MEAL"
}

export const isAIScanPackageFoodOption = (
  food: AllFoodType,
): food is IAIScanPackageFoodOption => {
  return food.source === "AI_SCAN_PACKAGE"
}

export const isAIScanNutritionFactOption = (
  food: AllFoodType,
): food is IAIScanPackageFoodOption => {
  return food.source === "AI_SCAN_NUTRITION_FACTS"
}

export function hasIngredientFoods(food: AllFoodType) {
  return isMyFood(food) || isAIScanFoodResponse(food)
}

export function hasIngredients(
  item: MealType | FoodType | IAIScanFoodOption
): item is WithIngredientsType {
  return item.source === "MY_FOOD" || item.source === "AI_SCAN_MEAL"
}
